import { ApiService, ApiServiceInterface } from "../../../../../core";
import { SubscriptionDataResponse } from "../../../site/interfaces";
import { SubscriptionPageController } from "../../core/controllers/SubscriptionPageController";

export class SubscriptionPageControllerImpl implements SubscriptionPageController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<SubscriptionDataResponse> {
        try {
            const response = await this.api.get('/subscription-page');
            return response;
        } catch (error) {

            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                return `Não foi possível encontrar os planos de assinatura neste momento (${error.message})`;
            }
        }
    }
}